import { inject, Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { Router } from '@angular/router';
import { EMPTY, from, Observable, switchMap, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { PushHttpService } from './push.http.service';

@Injectable()
export class PushService {
  private swPush = inject(SwPush);
  private pushHttp = inject(PushHttpService);
  private router = inject(Router);

  public readonly isEnabled = this.swPush.isEnabled;
  public readonly subscription$ = this.swPush.subscription;

  constructor() {
    this.swPush.notificationClicks.subscribe(({ notification }) => {
      const url = (notification.data as { url?: string })?.url;
      if (url) this.router.navigateByUrl(url);
    });
  }

  public subscribe(): Observable<void> {
    return from(this.swPush.requestSubscription({ serverPublicKey: environment.VAPID_PUBLIC_KEY })).pipe(
      switchMap(sub => this.pushHttp.saveSubscription(sub.toJSON()))
    );
  }

  public unsubscribe(): Observable<void> {
    return this.subscription$.pipe(
      take(1),
      switchMap(sub => {
        if (!sub) return EMPTY;
        return this.pushHttp.deleteSubscription(sub.endpoint).pipe(
          switchMap(() => from(this.swPush.unsubscribe()))
        );
      })
    );
  }
}
